<app-navbar></app-navbar>

<!-- Page Banner -->
<div class="rs-page-banner">
  <div class="rs-pb-deco">
    <div class="rs-pb-dots"></div>
    <div class="rs-pb-circle rs-pb-c1"></div>
    <div class="rs-pb-circle rs-pb-c2"></div>
  </div>
  <div class="container">
    <div class="rs-pb-content">
      <h1 class="rs-pb-title">News &amp; Events</h1>
      <nav class="rs-pb-breadcrumb">
        <a routerLink="/">Home</a>
        <i class="ri-arrow-right-s-line"></i>
        <span>News &amp; Events</span>
      </nav>
    </div>
  </div>
</div>

<!-- Content -->
<div class="rs-inner-page">
  <div class="container">

    <div *ngIf="!News_event_data" class="rs-empty-state">
      <i class="ri-newspaper-line"></i>
      <h4>No news or events found</h4>
    </div>

    <div class="row g-4" *ngIf="News_event_data">
      <div class="col-xl-4 col-lg-4 col-md-6 wow fadeIn"
           *ngFor="let item of News_event_data; let i = index"
           [attr.data-wow-delay]="(i * 0.08 + 0.1) + 's'">
        <div class="rs-news-card" [routerLink]="['/news-and-events', item.Id]">

          <!-- Thumbnail -->
          <div class="rs-news-thumb" *ngIf="item.ShowAttachments?.length">
            <img [src]="item.ShowAttachments[0].FilePath" [alt]="item.TitleEn"
                 onerror="this.parentElement.style.display='none'">
          </div>
          <div class="rs-news-thumb-placeholder" *ngIf="!item.ShowAttachments?.length">
            <i class="ri-newspaper-line"></i>
          </div>

          <div class="rs-news-body">
            <span class="rs-news-cat"><i class="ri-bookmark-line"></i> News &amp; Events</span>
            <h5 class="rs-news-title">{{ item.TitleEn }}</h5>
            <p class="rs-news-excerpt" [innerHTML]="item.DetailsEn"></p>
            <div class="rs-news-footer">
              <span class="rs-news-date">
                <i class="ri-calendar-2-line"></i>
                {{ item.CreatedDate | date:'dd MMM yyyy' }}
              </span>
              <a class="rs-news-cta" [routerLink]="['/news-and-events', item.Id]">
                Read <i class="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>
